import { GET_FEATURE_FLAGS, GET_COUNTRIES } from '@/utils/store/actionTypes'

export default async ({ store }, inject) => {
  if (process.server) {
    await Promise.allSettled([
      store.dispatch(`app/${GET_COUNTRIES}`),
      store.dispatch(`featureFlags/${GET_FEATURE_FLAGS}`)
    ])
  }

  const isEnabled = ({ name = '' }) => {
    if (!store.state.featureFlags || !store.state.featureFlags.flags || !store.state.featureFlags.flags.toggles) {
      return false
    }

    return store.state.featureFlags.flags.toggles.some(f => f.name === name && f.enabled)
  }

  inject('flags', { isEnabled })
}
